<div class="clock_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form #dynamicFormComponent [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <pre style="text-align: left; white-space: pre-line; font-size: 11px; padding-left: 30px; padding-top: 20px">
        D Day in month D DD
        H Hour in Dat 1-24
        M Minutes in hour M MM
        S Second in minutes SS
      </pre>
      <hr/>
      <app-font-selector (onChange)="onFontChanged($event, '', 'Countdown')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      <hr/>
      <br/>
    </div>
  }
</div>
